import { render, staticRenderFns } from "./bulkreallocation.vue?vue&type=template&id=1f92cb87"
import script from "./bulkreallocation.vue?vue&type=script&lang=js"
export * from "./bulkreallocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports